const mobileBreakpoint = window.matchMedia( '(max-width: 768px)' );
const swiperSelector = '.wp-block-create-block-sc-card-custom .sc-card-custom__cards-container--has-mobile-swiper .sc-card-custom__cards-mobile-swiper';

const initCardCustomMobileSwipers = () => {
	if ( ! mobileBreakpoint.matches || typeof Swiper === 'undefined' ) {
		return false;
	}
	const swiperContainers = document.querySelectorAll( swiperSelector );
	let initializedAnySwiper = false;

	swiperContainers.forEach( ( swiperContainer ) => {
		if ( swiperContainer.dataset.swiperInitialized === 'true' ) {
			return;
		}

		new Swiper( swiperContainer, {
			slidesPerView: 'auto',
			spaceBetween: 16,
			grabCursor: true,
			allowTouchMove: true,
			watchOverflow: true,
			resistanceRatio: 0.85,
		} );

		swiperContainer.dataset.swiperInitialized = 'true';
		swiperContainer.parentElement?.classList.add( 'is-swiper-ready' );
		initializedAnySwiper = true;
	} );

	return initializedAnySwiper;
};

const scheduleSwiperInitialization = () => {
	let attempts = 0;
	const maxAttempts = 20;

	const tryInitialize = () => {
		const swiperContainers = document.querySelectorAll( swiperSelector );
		const initialized = initCardCustomMobileSwipers();

		if ( initialized || ! mobileBreakpoint.matches || swiperContainers.length === 0 ) {
			return;
		}

		attempts += 1;

		if ( attempts < maxAttempts ) {
			window.setTimeout( tryInitialize, 150 );
		}
	};

	tryInitialize();
};

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', scheduleSwiperInitialization );
} else {
	scheduleSwiperInitialization();
}

window.addEventListener( 'load', scheduleSwiperInitialization );
mobileBreakpoint.addEventListener( 'change', scheduleSwiperInitialization );
